import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, FileText, Image as ImageIcon, MessageCircle, Video, Zap, ShieldCheck } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    icon: FileText,
    title: 'Sistema Mamá IA en PDF',
    desc: 'El método completo de 5 capítulos para crear tu producto digital con IA, diseñarlo y ponerlo a la venta. Paso a paso, sin saltar nada.'
  }, {
    icon: ImageIcon,
    title: 'Pack de Portadas Profesionales',
    desc: 'Plantillas editables para que tu producto se vea premium desde el primer día. Solo cambias el texto y listo.'
  }, {
    icon: MessageCircle,
    title: 'Scripts de Cierre por WhatsApp',
    desc: 'Los mensajes exactos para responder cuando alguien te escriba "info". Copias, pegas y cierras ventas.'
  }, {
    icon: Video,
    title: 'Directorio de Videos Faceless',
    desc: 'Dónde encontrar videos estéticos gratuitos para tus Reels. Cero necesidad de grabar o mostrar tu cara.'
  }, {
    icon: Zap,
    title: 'Acceso Inmediato al Sistema',
    desc: 'Recibes todo en tu correo al instante tras el pago. Puedes empezar a leer y aplicar hoy mismo.'
  }, {
    icon: ShieldCheck,
    title: 'Garantía de 7 Días',
    desc: 'Prueba el sistema completo. Si aplicas los pasos y no ves resultados, te devuelvo tu dinero. Cero riesgo.'
  }];
  return <section className="bg-white py-12 md:py-24 px-4" data-id="element-341">
      <div className="max-w-5xl mx-auto" data-id="element-342">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10 md:mb-16" data-id="element-343">
          <span className="text-primary font-bold uppercase tracking-wider text-sm mb-2 block" data-id="element-344">
            Tu Kit Completo
          </span>
          <h2 className="text-3xl md:text-5xl text-dark font-display font-extrabold tracking-headline" data-id="element-345">
            Todo Lo Que Recibes Hoy por $6.36
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-346">
          {items.map((item, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white border border-stone-200 rounded-2xl p-6 shadow-sm" data-id="element-347">
              <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mb-4" data-id="element-348">
                <item.icon className="w-6 h-6 text-primary" data-id="element-349" />
              </div>
              <h3 className="text-xl text-dark font-display font-bold mb-2 flex items-center gap-2" data-id="element-350">
                <CheckCircle2 className="w-5 h-5 text-primary" data-id="element-351" />
                {item.title}
              </h3>
              <p className="text-body leading-relaxed text-sm" data-id="element-352">{item.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}